export default __webpack_public_path__ + "static/media/Wheel-Blue.2a5237d3.png";